"use client"
import { FC, useEffect, useState } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import clsx from 'clsx';
import { CTAIcon, CTAVariant, PatternCTASet } from 'mmds';
import localisePath from '@app/lib/helpers/localise-path';
import { SliceZoneContext } from '@app/lib/prismic/types/slice-zone-context';
import { StravaProgressTrackerSlice } from 'prismicio-types';
import s from './StravaProgressTracker.module.css';

/**
 * Props for `PlanetaryLapsProgressTracker`.
 */
export type StravaProgressTrackerProps =
    SliceComponentProps<Content.StravaProgressTrackerSlice>;

interface StravaProgressTrackerPropsWithContext {
    slice: StravaProgressTrackerSlice;
    context: SliceZoneContext;
}

/**
 * Component for "StravaProgressTracker" Slices.
 */
// @ts-ignore
const StravaProgressTracker: FC<StravaProgressTrackerPropsWithContext> = ({
    slice,
    context
}) => {
    const [ activityTotal, setActivityTotal ] = useState(context.stravaActivityTotal || 0);
    useEffect(() => {
        if(context.stravaActivityTotal) {
            return;
        }
        const fetchActivityTotal = async () => {
             try {
                const apiURL = `${process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000'}/api/strava/get-activity-total?activityTotalCell=${slice.primary.total_kms_google_sheet_field || 'Sheet1!A1'}`;
                const activityTotalResponse = await fetch(apiURL);
                if (!activityTotalResponse.ok) {
                    throw new Error('Failed to fetch activity total');
                }
                const activityTotalData = await activityTotalResponse.json();
                const activityTotal = activityTotalData.activityTotal || 0;
                setActivityTotal(activityTotal)
            } catch(error) {
                console.error('Error fetching activity total:', error);
                return null
            }
        };
        fetchActivityTotal();
    }, [])
    if(!activityTotal) return null
    const formatter0DP = new Intl.NumberFormat('en-AU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const ctaSet = slice.items.map((item: any) => {
        const newItem = item as any;
        return {
            variant:
                newItem.button_variant?.toLowerCase() as CTAVariant,
            label: newItem.button_label as string,
            hrefLink: localisePath(
                newItem.button_link as string,
                context.lang
            ),
            icon: newItem.button_icon?.toLowerCase() as CTAIcon,
        };
    })
    return (
        <section
            data-slice-type={slice.slice_type}
            data-slice-variation={slice.variation}
            className={s.root}
        >
            {slice.primary.context && <h2 className="mmds-title-five-alt">
                {slice.primary.context ? slice.primary.context : null}
            </h2>}
            <h3 className="mmds-super-title">{formatter0DP.format(activityTotal)}'km</h3>
            <PatternCTASet set={ctaSet} lang={context.lang} />
        </section>
    );
};

export default StravaProgressTracker;
